import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Vendor } from '../interfaces/vendor.interface';
import { Filter } from '../interfaces/filter.interface';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class VendorService {
  private baseUrl = environment.apiBaseUrl;

  constructor(private http: HttpClient) { }

  listVendors(pageNumber = 1, pageSize = 10, term = '', filters?: Filter[], orderBy?: string, isCachable = false): Observable<any> {
    const data = {
      term,
      advancedFilter: filters ?? [],
      pageNumber,
      pageSize,
      orderBy: orderBy ? [orderBy] : [],
    };

    const header = isCachable ? { headers: { 'X-Use-Cache': 'true' } } : {};
    return this.http.post(`${this.baseUrl}/Vendor/List`, data, header).pipe(
      map((response: any) => response.data || response),
      catchError((error) => {
        console.error('Error fetching vendors:', error);
        throw error;
      })
    );
  }

  getVendor(id: number, isCachable = false): Observable<Vendor> {
    const header = isCachable ? { headers: { 'X-Use-Cache': 'true' } } : {};
    return this.http.get(`${this.baseUrl}/Vendor/${id}`, header).pipe(
      map((response: any) => response.data || response),
      catchError((error) => {
        console.error('Error fetching vendor:', error);
        throw error;
      })
    );
  }

  createVendor(data: Vendor): Observable<Vendor> {
    return this.http.post(`${this.baseUrl}/Vendor`, data).pipe(
      map((response: any) => response.data || response),
      catchError((error) => {
        console.error('Error creating vendor:', error);
        throw error;
      })
    );
  }
  getVendorLookup(
    pageNumber = 1,
    pageSize = 50,
    term = '',
    advancedFilter: Filter[] = [],
  ): Observable<any> {
    return this.http.post(`${this.baseUrl}/Lookup/Vendors`, {
      term,
      advancedFilter,
      includeDeleted: false,
      pageNumber,
      pageSize,
      orderBy: [],
      category: 'ALL',
    });
  }
  updateVendor(data: Vendor): Observable<Vendor> {
    return this.http.post(`${this.baseUrl}/Vendor`, data).pipe(
      map((response: any) => response.data || response),
      catchError((error) => {
        console.error('Error updating vendor:', error);
        throw error;
      })
    );
  }

  deleteVendor(id: number): Observable<any> {
    return this.http.delete(`${this.baseUrl}/Vendor/${id}`).pipe(
      map((response: any) => response.data || response),
      catchError((error) => {
        console.error('Error deleting vendor:', error);
        throw error;
      })
    );
  }

  exportVendors(payload: any): Observable<Blob> {
    return this.http.post(`${this.baseUrl}/Vendor/export`, payload, { responseType: 'blob' }).pipe(
      catchError((error) => {
        console.error('Error exporting vendors:', error);
        throw error;
      })
    );
  }
}
